export const REACT_APP_RECAPTCHA_API_KEY = process.env.REACT_APP_RECAPTCHA_API_KEY;
export const REACT_APP_MAP_ID = process.env.REACT_APP_MAP_ID;
export const REACT_APP_GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
export const REACT_APP_ENV = process.env.REACT_APP_ENV;
export const REACT_APP_ENDPOINT_CA = process.env.REACT_APP_ENDPOINT_CA;
export const REACT_APP_SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;
export const REACT_APP_MAINTENANCE_START = process.env.REACT_APP_MAINTENANCE_START;
export const REACT_APP_MAINTENANCE_END = process.env.REACT_APP_MAINTENANCE_END;